import FactoryTable from './factories/factoryTable';

/**
 * Возвращает фабрику для построения таблицы тарифов
 * @param tariff
 */
export const getTableFactory = ( tariff ) => {
  return new FactoryTable(tariff);
}